import { useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export const useUpdateSearchParams = (baseUrl: "/articles/conferencier/" | "/articles/actualite/") => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const updateSearchParams = useCallback(
    (search: Record<string, string | string[] | undefined | null>) => {
      const params = new URLSearchParams(searchParams);

      for (const [key, value] of Object.entries(search)) {
        if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
          params.delete(key);
        } else {
          if (Array.isArray(value)) {
            params.delete(key);
            for (const v of value) {
              params.append(key, v);
            }
          } else {
            params.set(key, value);
          }
        }

        if (key !== "page") {
          params.set("page", "1");
        }
      }

      router.push(`${baseUrl}?${params.toString()}`);
    },
    [router, searchParams, baseUrl],
  );

  return { updateSearchParams } as const;
};
